import { useTranslations } from 'next-intl';
import BottomSheetModal from '@/components/shared/BottomSheetModal';
import DailyBonusCard from './DailyBonusCard';

interface Props {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
}
const DailyBonusInformationDrawer = ({ isOpen, setIsOpen }: Props) => {
  const t = useTranslations('daily-bonus.information');
  return (
    <BottomSheetModal open={isOpen} onOpenChange={setIsOpen} contentClassName="overflow-x-visible">
      <div className="mb-11.5">
        <h3 className="text-base font-semibold leading-[120%] mb-3">{t('title')}</h3>
        <ul className="flex flex-col gap-3 list-disc pl-5">
          <li className="text-sm leading-5 font-regular">{t('description')}</li>
          <li className="text-sm leading-5 font-regular">{t('description-2')}</li>
          <li className="text-sm leading-5 font-regular">{t('description-3')}</li>
        </ul>
      </div>
      <h3 className="text-base font-semibold leading-[120%] mb-3">{t('card-states')}</h3>
      <div className="flex flex-col gap-6 overflow-x-visible mb-10">
        <div className="flex items-start gap-3 overflow-x-visible">
          <DailyBonusCard rewardAmount={0.5} bonusDays={7} state="ready" redirectToShop={true} className="w-14! h-16.5! shrink-0" />
          <div>
            <p className="font-medium text-sm leading-5 mb-1">{t('glowing-border')}</p>
            <p className="font-regular text-sm leading-5">{t('ready-to-claim')}</p>
          </div>
        </div>

        <div className="flex items-start gap-3 overflow-x-visible">
          <DailyBonusCard rewardAmount={0.5} bonusDays={7} state="claimed" className="w-14! h-16.5! shrink-0" />
          <div>
            <p className="font-medium text-sm leading-5 mb-1">{t('clock')}</p>
            <p className="font-regular text-sm leading-5">{t('already-claimed-for-today')}</p>
          </div>
        </div>

        <div className="flex items-start gap-3 overflow-x-visible">
          <DailyBonusCard rewardAmount={0.5} bonusDays={0} state="locked" className="w-14! h-16.5! shrink-0" />
          <div>
            <p className="font-medium text-sm leading-5 mb-1">{t('lock-with-bag')}</p>
            <p className="font-regular text-sm leading-5">{t('buy-the-matching-bundle-to-unlock-activations-stacked')}</p>
          </div>
        </div>
      </div>
      <p className="text-gradient font-semibold text-base leading-[120%] text-transparent bg-promo-banner-title-gradient mb-3">
        {t('don-t-miss-a-day')}
      </p>
      <p className="font-regular text-sm leading-5">
        {t('unclaimed-activations-expire-at-midnight-burns-1-activation-with-each-card-opened')}
      </p>
    </BottomSheetModal>
  );
};

export default DailyBonusInformationDrawer;
